"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var CalendarToday_1 = __importDefault(require("@material-ui/icons/CalendarToday"));
var pickers_1 = require("@material-ui/pickers");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var constants_1 = __importDefault(require("../../../../config/constants"));
var AccessibleDateInput = function (_a) {
    var id = _a.id, label = _a.label, labelProps = _a.labelProps, disableFuture = _a.disableFuture, theme = _a.theme, _b = _a.dateAriaLabel, dateAriaLabel = _b === void 0 ? 'Date Picker' : _b, pickerProps = __rest(_a, ["id", "label", "labelProps", "disableFuture", "theme", "dateAriaLabel"]);
    var classes = styles(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var arrowButtonProps = {
        leftArrowButtonProps: { 'aria-label': t('previousMonth', 'Previous month') },
        rightArrowButtonProps: { 'aria-label': t('nextMonth', 'Next month') }
    };
    var handleDialogEnter = function () {
        setTimeout(function () {
            var dialog = document.querySelector('.MuiPickersModal-dialogRoot');
            if (dialog) {
                dialog.setAttribute('aria-label', dateAriaLabel);
            }
            var firstFocusable = document.querySelector('.MuiPickersDay-daySelected');
            if (firstFocusable) {
                firstFocusable.focus();
            }
        }, 0);
    };
    var renderFullDateDay = function (day, selectedDate, isInCurrentMonth, dayComponent) {
        if (!day)
            return dayComponent;
        var fullDateLabel = (0, moment_1.default)(day).format('MMMM Do, YYYY');
        var isSelected = selectedDate && (0, moment_1.default)(day).isSame(selectedDate, 'day');
        var ariaLabel = isSelected ? "".concat(fullDateLabel, " (selected)") : fullDateLabel;
        return react_1.default.cloneElement(dayComponent, {
            'aria-label': ariaLabel
        });
    };
    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        (labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) && (react_1.default.createElement(Typography_1.default, { style: labelProps.labelStyle },
            label,
            labelProps.isRequiredLabel ? ' *' : '')),
        react_1.default.createElement(pickers_1.KeyboardDatePicker, __assign({}, arrowButtonProps, { style: { margin: '8px 8px' }, className: classes.root, DialogProps: {
                className: 'po-widget-datepicker',
                onEntered: handleDialogEnter,
                'aria-modal': true,
                'aria-label': "change ".concat(dateAriaLabel)
            }, renderDay: renderFullDateDay, inputVariant: constants_1.default.FIELDS_VARIANT, KeyboardButtonProps: {
                'aria-label': "change ".concat(dateAriaLabel)
            }, keyboardIcon: react_1.default.createElement(CalendarToday_1.default, null), label: !(labelProps === null || labelProps === void 0 ? void 0 : labelProps.useAlternateTextField) ? label : null }, pickerProps))));
};
var styles = function (theme) {
    return (0, styles_1.makeStyles)({
        root: {
            '& .MuiOutlinedInput-input': {
                border: '1px solid gray',
                borderRadius: '0',
                backgroundColor: theme.palette.background.paper,
                '&:focus': {
                    boxShadow: theme.shadows[3],
                    borderColor: theme.palette.grey[700]
                }
            }
        },
        datePicker: {
            '& .MuiPickersDay-daySelected': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.background.paper,
                '&:hover': {
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.primary.main
                }
            },
            '& .MuiButtonBase-root:hover': {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.primary.main
            }
        }
    });
};
exports.default = AccessibleDateInput;
//# sourceMappingURL=AccessibleDateInput.js.map